import { TileSize } from "game-common/models"

// Minimal shape needed to z-order a sprited-layer tile.
export interface SpritedTileZIndexItem {
    x: number
    y: number
    context?: { parent?: { x: number; y: number } }
}

// The cell row a sprited tile should sort by: its structure's base/anchor row (context.parent.y),
// falling back to its own cell when it has no parent (single-tile autotiles).
//
// A wall is two tiles -- a CAP at (x, y-1) and a BASE at (x, y) -- both stamped with
// parent = base cell. Anchoring both to the base row keeps a wall grouped as a unit AND splits
// *stacked* walls in the same contiguous column: the wall to the north sorts by its (higher) base
// row and the wall to the south by its (lower) base row. Previously the whole contiguous run was
// grouped to the run's bottom cell, so a north wall inherited the south wall's row and drew over an
// entity standing between them (occluding the player's head). Multi-tile fragments stamp every tile
// with their anchor origin as parent, so they still group as one unit.
export const spritedTileAnchorY = (item: SpritedTileZIndexItem): number => item.context?.parent?.y ?? item.y

// Z-index for a sprited tile anchored at cell row `anchorY`. Larger row (lower on screen) sorts in
// front. `index` is the layer index (small positive int). roughToFineCoordinates(y) === y*TileSize.
export const spritedTileZIndex = (index: number, anchorY: number): number =>
    100 + index + anchorY * TileSize + TileSize / 3
